// IE Hub - Dashboard Layout Component
// Common layout wrapper for dashboard pages with header and footer navigation

import { useState, ReactNode } from 'react';
import { Box } from '../ui';
import Header from './Header';
import BottomTabBar from './BottomTabBar';

interface DashboardLayoutProps {
  children: ReactNode;
  backgroundColor?: string;
  disableContentPadding?: boolean;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ 
  children, 
  backgroundColor = '#f9fafb',
  disableContentPadding = false
}) => {
  const [headerHeight, setHeaderHeight] = useState<number>(100);

  return (
    <>
      {/* Mobile View */}
      <Box sx={{
        display: { xs: 'flex', md: 'none' },
        height: '100dvh',
        width: '100vw',
        backgroundColor: '#f5f5f5',
        flexDirection: 'column',
        position: 'relative'
      }}>
        {/* Fixed Mobile Header */}
        <Header onHeightChange={setHeaderHeight} />

        {/* Content with padding for fixed header and footer */}
        <Box sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          backgroundColor,
          px: 2,
          pt: `calc(${headerHeight}px + 16px)`,
          pb: 'calc(80px + env(safe-area-inset-bottom))',
          overflow: 'auto'
        }}>
          {children}
        </Box>

        {/* Bottom Tab Bar for Mobile */}
        <BottomTabBar />
      </Box>

      {/* Desktop View */}
      <Box sx={{
        height: '100vh',
        width: '100vw',
        display: { xs: 'none', md: 'flex' },
        flexDirection: 'column',
        backgroundColor,
        overflow: 'hidden'
      }}>
        {/* Desktop Header */}
        <Header />

        {/* Content Area - Centered Container */}
        <Box sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          overflow: 'auto',
          backgroundColor,
          px: 2,
          py: 4
        }}>
          <Box sx={{
            width: '100%',
            maxWidth: '1216px',
            px: disableContentPadding ? 0 : 4
          }}>
            {children}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DashboardLayout;

